<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>合作往来</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.feature_code">
                <el-input
                    v-model="queryParams.feature_code"
                    placeholder="请输入特征码"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item" v-if="postList.partner_rid">
                <vDropdown
                    model_key="partner_rid"
                    model_name="请选择合作方"
                    :model_value_default="queryParams['partner_rid']"
                    request_uri="dropdownPartners"
                    @onDropChange="onDropChange"
                    ref="partner_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.product_rid">
                <vDropdown
                    model_key="product_rid"
                    model_name="请选择产品"
                    :model_value_default="queryParams['product_rid']"
                    request_uri="dropdownProducts"
                    :request_params="{ type_code: [11, 91] }"
                    @onDropChange="onDropChange"
                    ref="product_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.period">
                <vDropdown
                    model_key="period"
                    model_name="请选择期间"
                    :model_value_default="queryParams['period']"
                    request_uri="monthPeriods"
                    @onDropChange="onDropChange"
                    select_value="value"
                    ref="period_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.type">
                <vDropdown
                    model_key="type"
                    model_name="请选择类型"
                    :model_value_default="queryParams['type']"
                    request_uri="partnerCurrentType"
                    @onDropChange="onDropChange"
                    select_value="value"
                    ref="type_ref"
                ></vDropdown>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" icon="el-icon-plus" v-if="postList.addBtn">新增</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <!-- <crm-upload obj="partner_current"></crm-upload> -->
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="partner_current"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="in_array(item.prop, ['feature_code', 'partner_name', 'product_name'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <!-- <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="update(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="del(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column> -->
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';
import crmUpload from '../../../../common/Upload.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload
    },
    name: 'partnerCurrentComponent',
    data() {
        return {
            draggable: {
                data_name: 'partner_current'
            },
            down_loading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.recoveryQueryParams();
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                this.queryParams.partner_rid = this.postList.params.partner_rid;
                this.getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        //跳转详情
        toDetail(row, prop) {
            if (prop == 'feature_code' && row.rid != '') {
                this.$router.push({
                    path: '/partnerCurrentDetail',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'partner_name' && row.partner_rid != '') {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: row.partner_rid
                    }
                });
            } else if (prop == 'product_name' && row.product_rid != '') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: row.product_rid
                    }
                });
            }
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                partner_rid: this.postList.params && this.postList.params.partner_rid ? this.postList.params.partner_rid : '',
                product_rid: '',
                period: '',
                type: '',
                feature_code: ''
            };
            this.saveQueryParams();
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('partner_current_params', JSON.stringify(this.queryParams));
            }
        },
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('partner_current_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('partner_current', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).partner_current;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'partnerCurrentLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        //删除
        del(row) {
            onDelete(row.id, this, 'partnerCurrentDelete', row.rid);
        },
        //编辑
        update(rid) {
            this.$router.push({
                path: 'partnerCurrentEdit',
                query: {
                    type: 'update',
                    id: rid
                }
            });
        },
        //新增
        insert() {
            this.$router.push({
                path: 'partnerCurrentEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy(rid) {
            this.$router.push({
                path: 'partnerCurrentEdit',
                query: {
                    type: 'copy',
                    id: rid
                }
            });
        },
        reset() {
            this.initQueryParams();
            if (this.$refs.partner_rid_ref) {
                this.$refs.partner_rid_ref.reset();
            }
            if (this.$refs.product_rid_ref) {
                this.$refs.product_rid_ref.reset();
            }
            if (this.$refs.period_ref) {
                this.$refs.period_ref.reset();
            }
            if (this.$refs.type_ref) {
                this.$refs.type_ref.reset();
            }
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>